import { useSuspenseQuery } from '@tanstack/react-query'

import { GetProdutosService } from '@/http/get-produtos.service'
import type { TTipoProdutoPrecificadoBrasilEnum } from '@/types/produto'
import { produtosKeys } from '@/utils/produtos-query-keys'

export const useSuspenseProdutos = (
  idExternoBloco: number,
  tipoProduto: TTipoProdutoPrecificadoBrasilEnum,
  isVagaPadrao?: boolean,
) => {
  return useSuspenseQuery({
    queryKey: produtosKeys.lista({ idExternoBloco, tipoProduto, isVagaPadrao }),
    queryFn: () =>
      new GetProdutosService().execute(idExternoBloco, tipoProduto, isVagaPadrao).then((response) => response.data),
  })
}
